import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { MessageCircle, Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Las contraseñas no coinciden");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Contraseña actualizada. Inicia sesión.");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B0F14] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12 rounded-xl bg-[#25D366] flex items-center justify-center">
            <MessageCircle className="w-7 h-7 text-[#0B0F14]" strokeWidth={2.5} />
          </div>
          <h1 className="font-heading text-2xl font-extrabold text-slate-50">LeadFlow.WA</h1>
        </div>
        <div className="bg-[#111822] border border-[#1E2D3D] rounded-2xl p-8 shadow-2xl">
          <h2 className="font-heading text-xl font-bold text-slate-100 mb-6">Nueva contraseña</h2>
          {!token ? (
            <p className="text-sm text-red-400">Enlace inválido. Solicita uno nuevo.</p>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label className="text-slate-300 mb-2 block">Nueva contraseña</Label>
                <Input data-testid="reset-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-[#0B0F14] border-[#1E2D3D] text-slate-100 h-11" required />
              </div>
              <div>
                <Label className="text-slate-300 mb-2 block">Confirmar contraseña</Label>
                <Input data-testid="reset-confirm-input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="bg-[#0B0F14] border-[#1E2D3D] text-slate-100 h-11" required />
              </div>
              {error && <p className="text-sm text-red-400">{error}</p>}
              <Button data-testid="reset-submit-button" disabled={loading} className="w-full h-11 bg-[#25D366] hover:bg-[#22BF5B] text-[#0B0F14] font-semibold">
                {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Guardar"}
              </Button>
            </form>
          )}
          <div className="mt-6 text-center">
            <Link to="/login" className="text-sm text-slate-400 hover:text-[#25D366]">Volver a iniciar sesión</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
